import type { Chain } from 'viem';

export const getChainDisplayName = (chain?: Chain) => {
  if (!chain?.name) {
    return '';
  }

  return chain.name
    .replace(' Mainnet', '')
    .replace('BNB Smart Chain', 'BNB Chain')
    .replace('Binance Smart Chain', 'BNB Chain');
};
